var UnitType;
(function (UnitType) {
    UnitType[UnitType["Deaprtment"] = 1] = "Deaprtment";
    UnitType[UnitType["Role"] = 2] = "Role";
    UnitType[UnitType["User"] = 3] = "User";
})(UnitType || (UnitType = {}));
